export enum Goal {
  Ganon,
  AllDungeons,
  MasterSwordPedestal
}
